<!-- <ion-header>
  <ion-toolbar>
    <ion-title>{{title == 'full_description' ? 'Description' : '' }}</ion-title>
    <ion-icon class="fnt-20" (click)="get_value()" slot="end" name="close-outline"></ion-icon>
  </ion-toolbar>
</ion-header> -->
<ion-content>
  <!-- <ion-label>Description</ion-label> -->
  <quill-editor [(ngModel)]="text" name="text" class="text-editor flex-100 editor" type='textEditor'></quill-editor>
</ion-content>
<ion-footer class="ion-footer">
  <ion-toolbar>
    <ion-button (click)="get_value()" expand="full">Done</ion-button>
  </ion-toolbar>
</ion-footer>
